import { put, select } from 'redux-saga/effects'
import { track as trackEvent } from '../../actions/tracking'
import { setCurrentProduct } from '../../actions/ux'
import { selectProduct } from '../../selectors/product'
import { selectCurrentCollectionIndex } from '../../selectors/ux'

function* onProductSwipeLeft(action) {
  const { params: { id: productId } } = action.payload
  const product = yield select(selectProduct(productId))
  const position = (yield select(selectCurrentCollectionIndex)) + 1 // from 1 to N

  if (productId) {
    yield put(setCurrentProduct(productId))

    yield put(trackEvent({
      event: 'swipeleft',
      params: {
        id: product.id,
        title: product.title,
        position,
      },
    }))
  }
}

export default onProductSwipeLeft
